<template>
    <div class="container_bkg">
        <div class="container">

            <div class="active_title">{{ activeInfo.name }}</div>

            <div class="active_desc">完课即可领取好礼</div>

            <div class="time_box">
                <img class="time_icon"
                    src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/courseCompletionActivity/course_time_bkg.png"
                    alt="">

                <div class="time_text">活动倒计时：{{ countDownText }}</div>
            </div>

            <div class="course_num_box">

                <div class="course_num_top">
                    <img class="course_num_icon"
                        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/courseCompletionActivity/course_num_icon.png"
                        alt="">

                    <div class="course_num_text">我的完课进度</div>

                    <div class="course_num_all">/{{ activeInfo.courseCount }}次</div>
                    <div class="course_num_curr">{{ activeInfo.finishCount }}</div>
                </div>

                <div class="course_progress_box">
                    <div class="course_progress_bar" :style="{ width: progressPercent + '%' }"></div>
                </div>

                <div class="course_num_desc" v-if="activeInfo.courseCount > activeInfo.finishCount">再完成<span>{{
                    activeInfo.courseCount -
                    activeInfo.finishCount }}</span>次课程学习，即可解锁<span>{{ giveInfo.giveName }}</span></div>
                <div v-else class="course_num_desc">已解锁<span>{{ giveInfo.giveName }}</span></div>
            </div>

            <div class="give_box">
                <div class="general_title_box">
                    <div class="general_title_text">奖励</div>
                    <img class="general_title_img"
                        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/courseCompletionActivity/course_give_tip.png"
                        alt="">
                </div>

                <div :class="{ give_card: true, give_card_disable: activeInfo.courseCount > activeInfo.finishCount }">
                    <div class="give_img_box">
                        <img class="give_img" :src="giveInfo.giveImg" alt="">
                    </div>
                    <div class="give_info_box">
                        <div class="givo_info_name">{{ giveInfo.giveName }}</div>
                        <div class="givo_info_type" v-if="giveInfo.giveTypeName">{{ giveInfo.giveTypeName }}</div>
                    </div>

                    <div class="give_info_btn" @click="onPreGive"
                        v-if="activeInfo.finishCount >= activeInfo.courseCount && (!activeInfo.records || activeInfo.records.length == 0)">
                        领取</div>
                    <div class="give_info_btn give_info_btn_disable"
                        v-if="activeInfo.finishCount < activeInfo.courseCount">
                        差{{ activeInfo.courseCount - activeInfo.finishCount }}次解锁
                    </div>
                    <div class="give_info_btn" @click="onLookGive"
                        v-if="activeInfo.finishCount >= activeInfo.courseCount && activeInfo.records?.length > 0">查看
                    </div>
                </div>
            </div>

            <div class="rule_box">
                <div class="general_title_box">
                    <div class="general_title_text">活动规则</div>
                    <img class="general_title_img"
                        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/courseCompletionActivity/course_give_tip.png"
                        alt="">
                </div>

                <div class="rule_content">
                    <div>1. 完课判定标准：该系列课单场直播听课时长≥45分钟视为完成1节直播课，每达标1场计入完课1次；</div>
                    <div>2. 达到对应完课次数要求后，可点击「立即领取」领取对应奖品；</div>
                    <div>3. 优惠券将于领取后5分钟内发放至「我的-优惠券」；实物奖品&电子卡券类奖品（如饮品券）将于该系列课结束后7个工作日内安排发货；</div>
                    <div>4. 实物奖品请在活动有效期内填写收货地址，逾期未填写视为自动放弃奖品资格；</div>
                    <div>5. 电子卡券类奖品（如饮品券）将发放至奖品对应账户，请留意券面有效期，卡券过期自动失效，平台不予补发；</div>
                    <div>6. 本活动最终解释权归平台所有。</div>
                </div>
            </div>
        </div>

        <div class="modal_shade" v-if="modalVisible">
            <div class="modal_box">
                <div class="modal_title">领取成功</div>
                <div class="modal_tip">您领取的奖品为实物奖品<br>
                    我们将在活动结束后15日内发货~</div>
                <div class="modal_address">地址：{{ activeInfo.records[0]?.receiverAddress }}</div>
                <div class="modal_button" @click="onHideModal">知道了</div>
            </div>
        </div>
    </div>

</template>

<script>
import { timerCount, replaceHyphens } from '@/utils/tools';
import { getActiveInfo, receiveGive } from '@/api/courseCompletionActivity/index'

export default {

    data() {
        return {
            activeInfo: {},
            countDownText: '', // 倒计时文案
            countDownTimer: null, // 倒计时定时器
            serverTimeOffset: 0, // 服务器时间与本地时间的偏移量(ms)

            modalVisible: false,
        };
    },

    computed: {
        // 完课进度百分比，防除零、防超过100%
        progressPercent() {
            const { finishCount, courseCount } = this.activeInfo;
            if (!courseCount) return 0;
            const percent = (finishCount / courseCount) * 100;
            return Math.min(percent, 100);
        },
        giveInfo() {
            const { coupons, materials, others } = this.activeInfo
            const giveItem = materials?.[0] || coupons?.[0] || others?.[0] || {}
            const giveType = giveItem.type
            let result = {
                giveType,
                prizeId: giveItem.id,
            }

            console.log(giveItem.type, 'giveItem')

            // 优惠券
            if (giveType == 2) {
                result.giveImg = 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/courseCompletionActivity/course_coupon_icon.png'
                result.giveName = giveItem.couponName
                result.giveTypeName = "优惠券"
                result.giveToast = '前往我的优惠券查看'
            }

            // 实物
            if (giveType == 4) {
                result.giveImg = giveItem.prizePicture
                result.giveName = giveItem.prizeName
                result.giveTypeName = "实物"
                result.giveToast = ''
            }

            // 其它
            if (giveType == 5) {
                result.giveImg = 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/courseCompletionActivity/course_other_icon.png'
                result.giveName = giveItem.prizeName
                result.giveTypeName = ""
                result.giveToast = '奖品在活动结束后7个工作日内发放至账号'
            }

            return result
        },
    },

    created() {
    },

    mounted() {
        document.title = '完课活动'
        this.getInfo()
    },

    beforeDestroy() {
        this.clearCountDown();
    },

    methods: {
        // 初始化倒计时：以服务器时间为基准，算一次偏移量后本地自走
        initCountDown(serverTime) {
            const { endTime } = this.activeInfo;
            if (!endTime || !serverTime) return;
            // iOS 不识别 YYYY-MM-DD，需替换为 YYYY/MM/DD
            const end = new Date(replaceHyphens(endTime)).getTime();
            // 只算一次偏移量，之后每 tick 用 Date.now() + offset 还原服务器当前时间
            // 避免用户本地时间不准导致的误差
            this.serverTimeOffset = new Date(replaceHyphens(serverTime)).getTime() - Date.now();
            this.tick(end);
            this.countDownTimer = setInterval(() => {
                this.tick(end);
            }, 1000);
        },
        // 每 tick 用真实时间重算剩余时间，不用累减，避免 setInterval 延迟造成的漂移
        tick(end) {
            const remain = end - (Date.now() + this.serverTimeOffset);
            if (remain <= 0) {
                this.countDownText = '00天00:00:00';
                this.clearCountDown();
                // 倒计时结束，可在此处重新拉取活动信息
                // this.getActiveInfo();
                return;
            }
            const times = timerCount(remain, 2);
            this.countDownText = `${times.d}天${times.h}:${times.m}:${times.s}`;
        },
        clearCountDown() {
            if (this.countDownTimer) {
                clearInterval(this.countDownTimer);
                this.countDownTimer = null;
            }
        },

        getInfo() {
            getActiveInfo(this.$route.query.userProductId).then((res) => {
                console.log('res', res)
                this.activeInfo = res?.data || {}
                this.$nextTick(() => {
                    this.initCountDown(res.currentTime);
                })
                // 判断是否从地址也回来
                this.$nextTick(() => {
                    const isAddressBack = sessionStorage.getItem('courseCompletionActivity_address')
                    if (isAddressBack) {
                        sessionStorage.removeItem('courseCompletionActivity_address')
                        this.onGive()
                    }
                })
            })
        },

        // 领奖前置逻辑
        onPreGive() {
            console.log('开始领取')
            // 实物奖品要走地址页
            if (this.giveInfo.giveType == 4) {
                sessionStorage.setItem("courseCompletionActivity_address", true)
                this.$router.push({
                    path: '/personalCenter/address',
                    query: {
                        needBack: true,
                        isActive: true,
                    },
                });
            } else {
                this.onGive()
            }

        },
        // 真实领奖
        onGive() {
            const reqInfo = {
                id: this.activeInfo.id,
                userProductId: this.$route.query.userProductId,
                prizeId: this.giveInfo.prizeId
            }
            if (this.giveInfo.giveType == 4) {
                reqInfo.userAddressId = sessionStorage.getItem('addressId');
                sessionStorage.removeItem('addressId')
            }
            receiveGive(reqInfo).then((res) => {
                if (res.code == 0) {
                    this.$toast({
                        message: this.giveInfo.giveToast ? `领取成功，${this.giveInfo.giveToast}` : '领取成功',
                        className: 'toastIndex',
                    });
                }
                this.getInfo()
            })
        },

        // 查看领奖信息
        onLookGive() {

            // 优惠券
            if (this.giveInfo.giveType == 2) {
                this.$router.push({
                    path: '/personalCenter/myCoupon',
                });
            }
            // 实物
            if (this.giveInfo.giveType == 4) {
                this.modalVisible = true
            }
            // 其它
            if (this.giveInfo.giveType == 5) {
                this.$toast({
                    message: '奖品在活动结束后7个工作日内发放至账号',
                    className: 'toastIndex',
                });
            }
        },

        onHideModal() {
            console.log('???')
            this.modalVisible = false
        },
    },
};
</script>

<style lang="scss" scoped>
.container_bkg {
    background: #F7F8FC;
}

.container {
    background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/courseCompletionActivity/course_bkg.png') no-repeat;
    background-size: 100%;
    width: 750px;
    padding: 36px 36px 0;
    min-height: 100vh;

    .active_title {
        height: 51px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 36px;
        color: #FFFFFF;
        line-height: 51px;
    }

    .active_desc {
        height: 36px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 25px;
        color: #FFFFFF;
        line-height: 36px;
        margin-top: 7px;
    }

    .time_box {
        display: flex;
        align-items: center;
        width: 391px;
        height: 51px;
        background: #FFFADA;
        border-radius: 11px;
        margin-top: 25px;

        .time_icon {
            display: block;
            height: 51px;
            width: 60px;
        }

        .time_text {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 26px;
            color: #FF6C02;
            line-height: 51px;
        }
    }

    .course_num_box {
        width: 678px;
        height: 201px;
        background: #FFFFFF;
        border-radius: 14px;
        margin-top: 29px;
        padding: 29px 22px 29px;

        .course_num_top {

            // display: flex;
            height: 36px;

            .course_num_icon {
                display: block;
                height: 36px;
                width: 36px;
                float: left;
            }

            .course_num_text {
                float: left;
                height: 36px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 29px;
                color: #333333;
                line-height: 36px;
                margin-left: 11px;
            }

            .course_num_curr {
                float: right;
                height: 36px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 29px;
                color: #FF7F41;
                line-height: 36px;
            }

            .course_num_all {
                float: right;
                height: 36px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 29px;
                color: #333333;
                line-height: 36px;
            }
        }

        .course_progress_box {
            width: 634px;
            height: 18px;
            background: #F5F5F5;
            border-radius: 9px;
            margin-top: 36px;


            .course_progress_bar {
                height: 18px;
                background: #FF7F41;
                border-radius: 9px;
            }
        }

        .course_num_desc {
            height: 31px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 22px;
            color: #999999;
            line-height: 31px;
            margin-top: 22px;

            span {
                color: #FF7F41;
            }
        }


    }

    .general_title_box {
        position: relative;
        height: 40px;
        min-width: 56px;

        .general_title_text {
            position: absolute;
            height: 40px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 29px;
            color: #333333;
            line-height: 40px;
            top: 0;
            left: 0;
            z-index: 3;
        }

        .general_title_img {
            position: absolute;
            height: 9px;
            width: 56px;
            bottom: 0;
            left: 0;
            z-index: 1;
        }
    }

    .give_box {
        width: 678px;
        height: 257px;
        background: #FFFFFF;
        border-radius: 14px;
        margin-top: 22px;
        padding: 29px 22px;

        .give_card {
            width: 634px;
            height: 130px;
            background: linear-gradient(270deg, #FFFCED 0%, #FFEAD7 100%);
            border-radius: 14px;
            margin-top: 29px;
            overflow: hidden;

            .give_img_box {
                float: left;
                margin-left: 18px;
                margin-top: 18px;
                width: 94px;
                height: 94px;
                background: #FFFFFF;
                border-radius: 11px;
                display: flex;
                justify-content: center;
                align-items: center;

                .give_img {
                    display: block;
                    height: 58px;
                    width: 58px;
                }
            }

            .give_info_box {
                float: left;
                margin-top: 22px;
                margin-left: 14px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 81px;

                .givo_info_name {
                    height: 40px;
                    width: 300px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 29px;
                    color: #333333;
                    line-height: 40px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .givo_info_type {
                    width: 80px;
                    height: 34px;
                    background: #FEF5F1;
                    border-radius: 7px;
                    border: 1px solid #FF7F41;
                    margin-top: 7px;
                    font-weight: 400;
                    font-size: 22px;
                    color: #FF7F41;
                    line-height: 34px;
                    text-align: center;
                }
            }

            .give_info_btn {
                float: right;
                width: 129px;
                height: 42px;
                background: #FF7F41;
                border-radius: 23px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 22px;
                color: #FFFFFF;
                line-height: 42px;
                text-align: center;
                margin-top: 43px;
                margin-right: 29px;
            }

            .give_info_btn_disable {
                background: #CCCCCC;
                color: #FFFFFF;
            }

        }

        .give_card_disable {
            background: #F5F5F5;

            .givo_info_name {
                color: #999999 !important;
            }

            .givo_info_type {
                background: #F9F9F9 !important;
                border: 1px solid #D8D8D8 !important;
                color: #999999 !important;
            }
        }
    }

    .rule_box {
        width: 678px;
        // height: 395px;
        background: #FFFFFF;
        border-radius: 14px;
        margin-top: 22px;
        padding: 29px 22px;

        .rule_content {
            padding: 29px 7px 0;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 25px;
            color: #666666;
            line-height: 40px;
            display: flex;
            flex-direction: column;
            gap: 14px;
        }
    }

}

.modal_shade {
    position: fixed;
    z-index: 4;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.7);

    .modal_box {
        position: absolute;
        width: 634px;
        height: 466px;
        background: #FFFFFF;
        border-radius: 36px;
        top: 430px;
        left: 58px;

        .modal_title {
            height: 45px;
            width: 100%;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 33px;
            color: #333333;
            line-height: 45px;
            text-align: center;
            margin-top: 51px;
        }

        .modal_tip {
            height: 72px;
            width: 100%;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 25px;
            color: #333333;
            line-height: 36px;
            text-align: center;
            margin-top: 36px;
        }

        .modal_address {
            height: 72px;
            width: 491px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 25px;
            color: #FF1A3F;
            line-height: 36px;
            margin: 22px auto 0;
            text-align: center;
        }

        .modal_button {
            width: 418px;
            height: 80px;
            background: #FF7F41;
            border-radius: 40px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 25px;
            color: #FFFFFF;
            line-height: 80px;
            text-align: center;
            margin: 43px auto 0;
        }
    }
}
</style>
